import React, { useCallback, useEffect, useState, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShieldCheck, ShoppingCart, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button, SectionHeading } from './ui';
import { useCheckout } from './checkout-context';
const testimonialImages = ['https://cdn.shopify.com/s/files/1/0999/7487/3381/files/ChatGPT_Image_5_jun_2026_11_09_40.png?v=1780668721', 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/ChatGPT_Image_5_jun_2026_09_22_37.png?v=1780668722', 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/ChatGPT_Image_5_jun_2026_11_12_06.png?v=1780668810', 'https://cdn.shopify.com/s/files/1/0999/7487/3381/files/ChatGPT_Image_5_jun_2026_11_14_30.png?v=1780668880'];
export const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const total = testimonialImages.length;
  const next = useCallback(() => setIndex(i => (i + 1) % total), [total]);
  const prev = useCallback(() => setIndex(i => (i - 1 + total) % total), [total]);
  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);
  return <section className="py-20 bg-brand-gray overflow-hidden" data-id="element-71">
      <div className="max-w-3xl mx-auto px-4" data-id="element-72">
        <SectionHeading data-id="element-73">Lo que dicen las familias</SectionHeading>

        <div className="relative" data-id="element-74">
          <button onClick={prev} aria-label="Testimonio anterior" className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 md:-translate-x-5 z-20 bg-white text-brand-navy w-12 h-12 rounded-full shadow-lg flex items-center justify-center hover:bg-brand-pink hover:text-white transition-colors" data-id="element-75">
            <ChevronLeft className="w-6 h-6" data-id="element-76" />
          </button>
          <button onClick={next} aria-label="Siguiente testimonio" className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-2 md:translate-x-5 z-20 bg-white text-brand-navy w-12 h-12 rounded-full shadow-lg flex items-center justify-center hover:bg-brand-pink hover:text-white transition-colors" data-id="element-77">
            <ChevronRight className="w-6 h-6" data-id="element-78" />
          </button>

          <div className="px-2" data-id="element-79">
            <AnimatePresence mode="wait" data-id="element-80">
              <motion.div key={index} initial={{
              opacity: 0,
              x: 40
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -40
            }} transition={{
              duration: 0.35
            }} className="flex justify-center" data-id="element-81">
                <img src={`${testimonialImages[index]}&width=800&quality=80&format=webp`} alt={`Testimonio ${index + 1}`} width="800" height="800" loading="lazy" decoding="async" className="w-full max-w-xl h-auto rounded-3xl shadow-soft" data-id="element-82" />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="flex justify-center gap-2 mt-8" data-id="element-83">
            {testimonialImages.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} className={`h-3 rounded-full transition-all ${i === index ? 'w-8 bg-brand-pink' : 'w-3 bg-slate-300 hover:bg-slate-400'}`} data-id="element-84" />)}
          </div>
        </div>
      </div>
    </section>;
};
export const ValueStack = () => {
  const {
    orderBumpChecked,
    requestCheckout
  } = useCheckout();
  const finalPrice = orderBumpChecked ? '$31.998' : '$21.999';
  return <section className="py-20 bg-white" data-id="element-85">
      <div className="max-w-3xl mx-auto px-4" data-id="element-86">
        <SectionHeading data-id="element-87">Resumen de Valor</SectionHeading>

        <div className="bg-white border border-slate-200 rounded-3xl shadow-xl overflow-hidden" data-id="element-88">
          <div className="p-8 space-y-4" data-id="element-89">
            {[{
            name: 'Kit Educativo 15 en 1',
            value: '$360.000'
          }, {
            name: 'Bono 1: Trazos Maestros',
            value: '$4.999'
          }, {
            name: 'Bono 2: Mundo de Formas',
            value: '$4.999'
          }, {
            name: 'Bono 3: Super Colorea',
            value: '$9.999'
          }, {
            name: 'Bono 4: Mega Juegos',
            value: '$9.999'
          }, {
            name: 'Bono 5: Biblioteca Cuentitos',
            value: '$8.999'
          }, {
            name: 'Bono 6: Diploma Estrella',
            value: '$3.999'
          }].map((item, i) => <div key={i} className="flex justify-between items-center py-3 border-b border-slate-100 last:border-0" data-id="element-90">
                <span className="font-medium text-slate-700 flex items-center gap-2" data-id="element-91">
                  <ShieldCheck className="w-5 h-5 text-brand-green" data-id="element-92" />{' '}
                  {item.name}
                </span>
                <span className="font-bold text-slate-400" data-id="element-93">{item.value}</span>
              </div>)}
          </div>

          <div className="bg-brand-gray p-8 text-center border-t border-slate-200" data-id="element-94">
            <div className="text-slate-500 mb-2" data-id="element-95">
              Valor Total:{' '}
              <span className="line-through text-xl" data-id="element-96">$402.994</span>
            </div>
            <div className="font-heading text-6xl text-brand-pink mb-2" data-id="element-97">
              HOY SOLO {finalPrice}
            </div>
            <div className="inline-block bg-brand-green/20 text-brand-green font-bold px-4 py-1 rounded-full mb-8" data-id="element-98">
              Ahorras $381.000
            </div>

            <Button size="xl" className="w-full" onClick={requestCheckout} data-id="element-99">
              <ShoppingCart className="w-6 h-6 mr-2" data-id="element-100" />
              AGREGAR AL CARRITO
            </Button>
          </div>
        </div>
      </div>
    </section>;
};
export const Guarantee = () => <section className="py-12 bg-brand-gray" data-id="element-101">
    <div className="max-w-4xl mx-auto px-4" data-id="element-102">
      <div className="bg-white rounded-3xl p-8 md:p-12 shadow-soft flex flex-col md:flex-row items-center gap-8 text-center md:text-left border-t-8 border-brand-green" data-id="element-103">
        <div className="w-24 h-24 bg-brand-green/10 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-104">
          <ShieldCheck className="w-12 h-12 text-brand-green" data-id="element-105" />
        </div>
        <div data-id="element-106">
          <h3 className="font-heading text-3xl text-brand-navy mb-4" data-id="element-107">
            Garantía de 7 días — Sin riesgos
          </h3>
          <p className="text-lg text-slate-600" data-id="element-108">
            Prueba el material durante 7 días. Si por alguna razón sientes que
            no es lo que esperabas o no estás conforme, te devolvemos el 100% de
            tu dinero. Sin preguntas, sin riesgos.
          </p>
        </div>
      </div>
    </div>
  </section>;